import { locationTable } from '@digitale-verhuurders-verklaring/rds/src/schema/location.sql';
import { createSelectSchema } from 'drizzle-zod';
import { z } from 'zod';

import { teamDetailSchema, teamSchema } from './team';
import { userDetailSchema } from './user';

export const locationSchema = createSelectSchema(locationTable);
export const locationWithUserAmountSchema = locationSchema.merge(
  z.object({
    userAmount: z.number(),
  }),
);

export const locationWithTeamsSchema = locationSchema.merge(
  z.object({
    teams: z.array(teamSchema),
  }),
);

/** Uses z.lazy to break circular dependency: user → location → team → user. */
export const locationDetailSchema = locationSchema.merge(
  z.object({
    teams: z.array(teamDetailSchema),
    users: z.array(z.lazy(() => userDetailSchema)),
  }),
);

export const locationInsertSchema = locationSchema.pick({
  name: true,
  organisationId: true,
  notificationEnabled: true,
});
export const locationUpdateSchema = locationSchema.pick({
  id: true,
  name: true,
  organisationId: true,
  notificationEnabled: true,
});
export const locationDeleteSchema = locationSchema.pick({
  id: true,
  name: true,
  organisationId: true,
  deleted: true,
  deletedAt: true,
});

export type Location = z.infer<typeof locationSchema>;
export type LocationWithUserAmount = z.infer<
  typeof locationWithUserAmountSchema
>;
export type LocationDetail = z.infer<typeof locationDetailSchema>;
export type LocationInsert = z.infer<typeof locationInsertSchema>;
export type LocationUpdate = z.infer<typeof locationUpdateSchema>;
export type LocationDelete = z.infer<typeof locationDeleteSchema>;

export const locationAddRequestSchema = locationInsertSchema.pick({
  organisationId: true,
});
export type LocationAddRequest = z.infer<typeof locationAddRequestSchema>;
export const locationDeleteRequestSchema = locationDeleteSchema.pick({
  id: true,
});
export type LocationDeleteRequest = z.infer<typeof locationDeleteRequestSchema>;

export const locationModalDataSchema = z.union([
  z.object({
    type: z.literal('add'),
    data: locationAddRequestSchema,
  }),
  z.object({
    type: z.literal('edit'),
    data: locationUpdateSchema,
  }),
  z.object({
    type: z.literal('delete'),
    data: locationDeleteSchema,
  }),
]);

export type LocationModalData = z.infer<typeof locationModalDataSchema>;
